// https://github.homeawaycorp.com/hacommons/hacommons-i18n/blob/master/src/main/resources/com/homeaway/commons/i18n/formatter/i18nCurrencySymbols.properties
import CORRECTED_CURRENCY_SYMBOLS from './data/currency/symbols.json';
import { getSanitizedLocaleForIntl } from './localeUtils';
import { getCurrencyFormatByLocale } from './currencyUtils';
export { default as CURRENCY_PRECISIONS } from './data/currency/precisions.json';
/**
 * Resolves a single currency symbol based on currency code and locale
 *
 * @param currencyCode the currency code for the currency you wish to add (eg 'USD', 'AUD', 'GBP')
 * @param locale the locale to determine the format of the result (eg 'en', 'en_US' or 'en_US_HA', defaults to 'en_US')
 * @returns currency symbol based on ISO 4217 Currency Code.
 */

export var getCorrectedCurrencySymbol = function getCorrectedCurrencySymbol(currencyCode, locale) {
  if (locale === void 0) {
    locale = 'en_US';
  }

  var sanitizedLocale = getSanitizedLocaleForIntl(locale);
  var country = sanitizedLocale.split('-')[1];
  return CORRECTED_CURRENCY_SYMBOLS.hasOwnProperty(country) ? CORRECTED_CURRENCY_SYMBOLS[country].symbols[currencyCode] || CORRECTED_CURRENCY_SYMBOLS.DEFAULT.symbols[currencyCode] : CORRECTED_CURRENCY_SYMBOLS.DEFAULT.symbols[currencyCode];
};
/**
 * Returns all corrected currency symbols consolidated based on locale
 *
 * @param locale the locale to determine the format of the result (eg 'en', 'en_US' or 'en_US_HA', defaults to 'en_US')
 * @returns all consolidated currency symbols.
 */

export var getConsolidatedCurrencySymbols = function getConsolidatedCurrencySymbols(locale) {
  if (locale === void 0) {
    locale = 'en_US';
  }

  var sanitizedLocale = getSanitizedLocaleForIntl(locale);
  var country = sanitizedLocale.split('-')[1];
  return CORRECTED_CURRENCY_SYMBOLS.hasOwnProperty(country) ? Object.assign({}, CORRECTED_CURRENCY_SYMBOLS.DEFAULT.symbols, CORRECTED_CURRENCY_SYMBOLS[country].symbols) : CORRECTED_CURRENCY_SYMBOLS.DEFAULT.symbols;
}; // Use HomeAway specific format instead of the international standard

export var replaceWithHomeAwayFormatting = function replaceWithHomeAwayFormatting(formattedNumber, currency, locale, value) {
  // original implementation:
  // https://github.expedia.biz/vrbo-globalization/hacommons-i18n/blob/23891f9f3229ac530b84e9bde554265db674498e/src/main/java/com/homeaway/commons/i18n/formatter/GlobalCurrencyFormatter.java#L131-L147
  var localesNonCompliantWithStandard = ['it_IT'];

  if (localesNonCompliantWithStandard.includes(locale)) {
    return getCurrencyFormatByLocale(value, locale).replace('%s', currency).replace('%v', formattedNumber.replace(/(-?)(\s*[A-Z]*\s*)/g, ''));
  }

  return formattedNumber;
}; // Use HomeAway specific currency symbols instead of the international standard (eg AU$ instead of $)

export var replaceWithHomeAwayCurrencySymbol = function replaceWithHomeAwayCurrencySymbol(formattedNumber, currency, locale) {
  var correctedCurrency = getCorrectedCurrencySymbol(currency, locale);

  if (!correctedCurrency) {
    return formattedNumber;
  } // USD override


  if (currency === 'USD') {
    return formattedNumber.replace(RegExp(currency + "\\s*"), correctedCurrency);
  }

  return formattedNumber.replace(currency, correctedCurrency);
};
//# sourceMappingURL=currencyInfo.js.map